module.exports = __webpack_public_path__ + "img/AnyPayROUND_240px.6d780a93.png";